module.exports = __webpack_public_path__ + "static/media/img-3.b8328fd0.jpg";